import { Injectable } from '@angular/core';
import { createSelector } from '@ngrx/store';
import { AppState, IAddressState } from '../app.state';
import { BaseSelector } from '../base.selector';

@Injectable()
export class AddressSelector extends BaseSelector<IAddressState> {
	protected stateSelector = (state: AppState): IAddressState => state.address;

	public isSuggesting = createSelector(this.selectState, state => state.isSuggesting);
	public suggestedPayerList = createSelector(this.selectState, state => state.suggestedPayerList);
	public suggestedPayerComplete = createSelector(this.suggestedPayerList, addresses => addresses.find(a => a.street && a.streetNumber && a.postCode && a.city && a.country));
	public suggestedPayerIncomplete = createSelector(this.suggestedPayerList, addresses => addresses.filter(a => a.city && a.country));
	public suggestedReceiverList = createSelector(this.selectState, state => state.suggestedReceiverList);
	public suggestedReceiverComplete = createSelector(this.suggestedReceiverList, addresses => addresses.find(a => a.street && a.streetNumber && a.postCode && a.city && a.country));
	public suggestedReceiverIncomplete = createSelector(this.suggestedReceiverList, addresses => addresses.filter(a => a.city && a.country));
	public paging = createSelector(this.selectState, state => state.paging);
}
